.avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid var(--line2);
  border-radius: 50%;
  background: linear-gradient(135deg, var(--maroon), var(--magenta));
  color: #fff;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.3px;
}
.sm {
  width: 22px;
  height: 22px;
  font-size: 9px;
}
.muted {
  background: var(--surf2);
  color: var(--text2);
}
